import moment from "moment";
import {
    formatDateOnly,
    formatNullableDateTime,
    formatNullableTimeOnly,
    formatReservaStatus,
} from "consts/hotel";
import { transformDNI } from "services/Local-services";

const formatDocumento = (value) => {
    if (value == null || value === "") return "";
    const digits = String(value).replace(/\D/g, "");
    if (!digits) return String(value);
    return transformDNI(digits);
};

export const formatUltimoEstado = (value) => {
    if (value == null || value === "") return "";
    // Value que recibe 2026-05-19 19:48:02
    const str = String(value).trim();
    const parsed = moment(str, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss"]);
    if (parsed.isValid()) {
        const fecha = parsed.format("DD/MM/YYYY");
        const hora = parsed.format("HH:mm");
        return `${fecha} ${hora}`;
    }
    return "";
};


export const mapHotelUsuarioRow = (item, index) => ({
    id: item.SFHabitacionHuespedId,
    SFHabitacionHuespedId: item.SFHabitacionHuespedId,
    SFHabitacionId: item.SFHabitacionId,
    habitacionNumero: item.SFHabitacionNumero,
    habitacionPiso: item.SFHabitacionPiso,
    usuarioApellidos: item.usuarioApellidos,
    usuarioNombres: item.usuarioNombres,
    tipoDeDocumentoCod: item.tipoDeDocumentoCod,
    usuarioNroDeDocumento: formatDocumento(item.usuarioNroDeDocumento),
    usuarioFechaDeNacimiento: formatDateOnly(item.usuarioFechaDeNacimiento),
    imagen: item.imagePathSELFIE || 'texto',
    fechaDesde: item.SFHabitacionHuespedFechaDesde,
    fechaHasta: item.SFHabitacionHuespedFechaHasta,
    noches: item.SFHabitacionHuespedNoches,
    checkin: formatUltimoEstado(item.SFHabitacionHuespedCheckin),
    checkout: formatUltimoEstado(item.SFHabitacionHuespedCheckout),
    SFHotelCheckout: item.SFHotelCheckout,
    reserva: formatUltimoEstado(item.SFHabitacionHuespedReserva),
    reservaStatus: formatReservaStatus(item.SFHabitacionHuespedReservaStatus),
    reservaStatusCode: item.SFHabitacionHuespedReservaStatus,
    cancelacion: formatUltimoEstado(item.SFHabitacionHuespedCancelacion),
    reservaUltimoEstado: formatUltimoEstado(item.SFHabitacionHuespedEstadoUfh),
    vouchersUtilizadosCantidad: item.SFVouchersUtilizadosCantidad,
    numeroVouchersUtilizados: item.SFVouchersUtilizadosNumeros,
});

export const mapHotelUsuarioList = (result) => {
    if (!Array.isArray(result) || !result[0]?.usuarioId) {
        return [];
    }
    return result.map((item, index) => mapHotelUsuarioRow(item, index));
};
